import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { UsageDetails } from './constant'
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import EpiContext from '@episerver/spa-core/Spa';


function MoreInfoPopup(props) {
  const usageInfo = UsageDetails[props.usageInfo.type];
  return (
    <div className='cellularPackage_MoreInfoPopup'>
      <Image src={usageInfo.icon} />
      <p className='title'>מה קורה כשהחבילה מסתיימת?</p>
      <p className='text grayText'>{usageInfo.moreInfoText}</p>
      {usageInfo.displayExtendedLink &&
        <BtnSubmit text={usageInfo.btnText} onclick={() => EpiContext.navigateTo(props.usageInfo.link)} />
      }
    </div>
  )
}

MoreInfoPopup.propTypes = {

}

export default MoreInfoPopup
